var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.79639 8.2028L4.1791 2.64334C4.56697 1.73831 5.55525 1.13916 6.65957 1.13916H19.1332C20.2375 1.13916 21.2258 1.73831 21.6137 2.64334L23.9964 8.2028M3.81457 17.2846V19.3028H1.79639V17.2846M23.9964 17.2846V19.3028H21.9782V17.2846M1.79639 8.2028H23.9964V17.2846H1.79639V8.2028Z",
    stroke: "currentColor",
    strokeWidth: 2.11909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83282 13.2482C6.39013 13.2482 6.84191 12.7964 6.84191 12.2391C6.84191 11.6818 6.39013 11.23 5.83282 11.23C5.27552 11.23 4.82373 11.6818 4.82373 12.2391C4.82373 12.7964 5.27552 13.2482 5.83282 13.2482Z",
    stroke: "currentColor",
    strokeWidth: 1.74068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9605 13.2482C20.5178 13.2482 20.9696 12.7964 20.9696 12.2391C20.9696 11.6818 20.5178 11.23 19.9605 11.23C19.4032 11.23 18.9514 11.6818 18.9514 12.2391C18.9514 12.7964 19.4032 13.2482 19.9605 13.2482Z",
    stroke: "currentColor",
    strokeWidth: 1.74068,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarIcon);
export default __webpack_public_path__ + "static/media/car-icon.2044880f.svg";
export { ForwardRef as ReactComponent };